import React from 'react';
import { StarIcon, ShieldCheckIcon, ArrowPathIcon } from '@heroicons/react/24/solid';

const badges = [
  { label: 'G2 Leader', sub: 'Spring 2025', color: 'orange' },
  { label: 'G2 High Performer', sub: 'Spring 2025', color: 'orange' },
  { label: 'Clay Certified', sub: 'Integration Partner', color: 'purple' },
  { label: 'Most Loved', sub: 'User Sentiment', color: 'pink' },
];

export default function TrustBadges() {
  return (
    <section className="py-16 bg-gray-50 border-y border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Left stats */}
          <div className="flex items-center gap-6">
            <div className="text-center">
              <div className="flex items-center gap-1 justify-center">
                <span className="text-3xl font-extrabold text-gray-900">4.8</span>
                <StarIcon className="w-6 h-6 text-yellow-400" />
              </div>
              <p className="text-xs text-gray-500 mt-1">Rating on G2</p>
            </div>
            <div className="w-px h-10 bg-gray-200" />
            <div className="flex items-center gap-2">
              <ShieldCheckIcon className="w-6 h-6 text-indigo-600" />
              <div>
                <p className="text-sm font-semibold text-gray-800">GDPR Compliant</p>
                <p className="text-xs text-gray-400">EU data protection</p>
              </div>
            </div>
            <div className="w-px h-10 bg-gray-200" />
            <div className="flex items-center gap-2">
              <ArrowPathIcon className="w-6 h-6 text-green-500" />
              <div>
                <p className="text-sm font-semibold text-gray-800">Weekly refreshed</p>
                <p className="text-xs text-gray-400">Always fresh data</p>
              </div>
            </div>
          </div>

          {/* Badges */}
          <div className="flex flex-wrap gap-3 justify-center">
            {badges.map((b) => (
              <div key={b.label} className={`
                flex flex-col items-center justify-center w-24 h-24 rounded-2xl border-2 text-center p-2
                ${b.color === 'orange' ? 'border-orange-200 bg-orange-50' : ''}
                ${b.color === 'purple' ? 'border-purple-200 bg-purple-50' : ''}
                ${b.color === 'pink' ? 'border-pink-200 bg-pink-50' : ''}
              `}>
                <div className={`text-xl mb-1 ${b.color === 'orange' ? 'text-orange-500' : b.color === 'purple' ? 'text-purple-500' : 'text-pink-500'}`}>
                  {b.color === 'orange' ? '🏆' : b.color === 'purple' ? '🔷' : '❤️'}
                </div>
                <p className={`text-xs font-bold leading-tight ${b.color === 'orange' ? 'text-orange-700' : b.color === 'purple' ? 'text-purple-700' : 'text-pink-700'}`}>{b.label}</p>
                <p className="text-xs text-gray-400 mt-0.5">{b.sub}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center lg:text-right">
            <a href="#" className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl text-sm shadow-sm transition-colors block mb-2">
              Get started for free
            </a>
            <a href="#" className="text-xs text-indigo-600 hover:underline">View all reviews →</a>
          </div>
        </div>
      </div>
    </section>
  );
}
